import React, { useCallback } from "react";
import { FormControlLabel, FormGroup, Switch } from "@mui/material";
import LightModeIcon from "@mui/icons-material/Brightness7";
import DarkModeIcon from "@mui/icons-material/Brightness4";
import { usePaletteMode } from "./VCThemeProvider";
export const ThemeModeSwitcher = () => {
    const { mode, setMode } = usePaletteMode();
    const handleModeChange = useCallback((e) => {
        setMode(e.currentTarget.checked ? "light" : "dark");
    }, [setMode]);
    return (React.createElement(FormGroup, { sx: { display: 'flex', flexDirection: 'row' } },
        React.createElement(FormControlLabel, { control: React.createElement(Switch, { checked: mode === 'light', onChange: handleModeChange }), componentsProps: { typography: { lineHeight: '1em' } }, label: mode === 'light' ? React.createElement(LightModeIcon, null) : React.createElement(DarkModeIcon, null) })));
};
//# sourceMappingURL=ThemeModeSwitcher.js.map